import { PageDtoResponse } from '@asset-metrix/portal-gateway-client-js';
import { QueryFunction } from '@tanstack/react-query';

import { extractErrorMessage } from '../../utils/errorMessage';
import {
  QueryKeyWithRole,
  unwrapQueryKeyWithRole,
} from '../../utils/prependRoleId';
import { HttpError } from '../errors';
import { portalGatewayClient } from '../portalGatewayClient';

export type PageQueryKey = readonly [string];

export const fetchPage: QueryFunction<
  PageDtoResponse,
  QueryKeyWithRole<PageQueryKey>
> = async ({ queryKey }) => {
  const [pageId] = unwrapQueryKeyWithRole(queryKey).params;

  const response = await portalGatewayClient.page.getPage(pageId);

  if (!response.ok) {
    throw new HttpError(
      extractErrorMessage(response.error, 'Error fetching page.'),
      response
    );
  }
  return response.data;
};
